import React, { Component } from 'react';
import Article from './Article';
import Aside from './Aside';

class Home extends Component {
  render() {
    return (
      <Article asideArticle = {<Journey onAsideSection={this.props.onAsideSection} />}>
        <div id="article-main" className="flex-overflow-item">
          <h2>Me</h2>
          <p>
            I am a recent graduate of the University of Washington with 2 years experience professionally as Full-Stack Software Developer.
            I enjoy discovering new places, exploring delicious cuisines, and spending time outdoors. Professionally, I'm possitive and self-motivated.
            I love learning new technologies and developing beautiful, frustration free software that people love to use. <a href="/resume" className="more-link" onClick={this.props.onSectionChange.bind(this, "resume")}>My Resume</a>
          </p>
          <h3>Chasing Dreams</h3>
          <p>
            We all have dreams we want to fulfill whether its travelling to Tokyo, finding a cure for degenrative diseases, or simply finding a space to call our own. 
            Having lofty dreams and pursuing them with all our passion can be a difficult and daunting task, one that exposes us to the risk of failure and the potential shame of defeat.
          </p>
          <p>
            But, it's also a rewarding and transformational journey.
          </p>
          <p>
            I believe in the transformative power of pursuing our dreams. Though we may suffer setbacks and failures, if we keep
            moving forward, I believe we will gain so much from the journey.
            We will gain a new understanding and a new belief in ourselves. We can overcome our doubts, ovecome our fears, and drop the things that hold us back. {/*<a href="/journey" className="more-link" onClick={this.props.onAsideSection.bind(this, true)}>My Journey <i class="fas fa-long-arrow-alt-right"></i></a>*/}
          </p>
        </div>
      </Article>
    );
  }
}
  
class Journey extends Component {
  render() {
    return (
      <Aside onAsideSection={this.props.onAsideSection}>
        <h2>My Journey</h2>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vestibulum odio ut fringilla tempor. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Integer sit amet leo sapien. Phasellus eleifend sem eu metus commodo, ut interdum ligula dictum. Morbi finibus nisi eget mauris imperdiet, nec pretium purus viverra. Donec euismod enim tortor, a ultrices nibh pretium eu. In hac habitasse platea dictumst. Aliquam nisl justo, bibendum vitae diam at, blandit porttitor ex. Phasellus efficitur est quis ex congue condimentum. Fusce aliquet quam sit amet dui euismod luctus. Nam interdum lobortis eros et pretium.
        </p>
        <h3>My Dreams</h3>
        <p>
          Donec ac ex quam. Phasellus in iaculis urna. Donec ullamcorper ornare odio sed mollis. Nulla sed tincidunt sapien. Sed in varius sem. Suspendisse auctor arcu eget diam pellentesque, id blandit nisi mollis. Donec nec luctus enim. Aliquam erat volutpat. Phasellus at mi aliquam, dignissim tortor sit amet, posuere erat. Nullam est nunc, posuere ac enim ut, molestie imperdiet magna. Praesent suscipit facilisis gravida. Curabitur tempus augue in eros dapibus sollicitudin.
        </p>
        <p>
          Asd ggr bbt lasetst
        </p>
      </Aside>
    );
  }
}

export default Home;


// WEBPACK FOOTER //
// ./src/Home.js